export default __webpack_public_path__ + "static/11-6821f2b8dbc372f92124b46472bc74ac.jpg";